import {Box, ListItemIcon, ListItemText, MenuItem, Select, Tooltip, Typography} from "@mui/material";
import React from "react";
import {questionTypeList} from "../enums";


export const SelectQuestionType = ({type, setType}) => {

  return (
    <Box>
      <Typography gutterBottom fontWeight={500}>Type</Typography>
      <Select
        value={type} fullWidth variant={"outlined"}
        onChange={(e) => setType(e?.target?.value)}
        inputProps={{
          sx: {display: "flex", flexDirection: "row", gap: 1, alignItems: "center"}
        }}
      >
        {questionTypeList?.map(questionItem => {
          const Icon = questionItem?.icon;
          return (
            <MenuItem
              key={`outlined-select-option-${questionItem.type}`}
              value={questionItem?.type?.toString()}
              sx={{display: "flex", flexDirection: "row", gap: 1, alignItems: "center"}}
            >
              <ListItemIcon sx={{minWidth: 0}}><Icon/></ListItemIcon>
              <Tooltip title={questionItem?.description}>
                <ListItemText primary={questionItem.name}/>
              </Tooltip>
            </MenuItem>
          )
        })}
      </Select>

    </Box>
  )
}